<template>
  <div>
    <b-modal
      id="bet-info"
      ref="betModal"
      centered
      size="md"
      hide-header
      hide-footer
      body-class="p-0 rounded"
    >
      <div
        v-if="selectedBet"
        style="padding: 16px; color: #1a1a1a; font-family: inherit"
      >
        <!-- Header -->
        <div
          class="d-flex flex-wrap justify-content-between align-items-start"
          style="margin-bottom: 4px"
        >
          <h5 style="font-weight: 700; margin: 0; font-size: 16px">Bet</h5>
          <b-button
            variant="flat-secondary"
            style="padding: 0; line-height: 1"
            @click="closeModal"
          >
            <feather-icon icon="XIcon" size="16" class="text-muted" />
          </b-button>
        </div>
        <p
          style="
            font-size: 11px;
            color: #6b7280;
            margin-bottom: 12px;
            line-height: 1.4;
          "
        >
          View and manage bet details. Select an event to cancel the leg for the
          bet.
        </p>

        <!-- Customer Info -->
        <div
          class="d-flex align-items-center"
          style="margin-bottom: 14px; gap: 10px"
        >
          <b-avatar :text="avatarInitials" size="40px" class="flex-shrink-0" />
          <div>
            <div
              class="d-flex align-items-center"
              style="gap: 6px; flex-wrap: wrap; margin-bottom: 2px"
            >
              <span style="font-weight: 700; font-size: 14px">{{
                selectedBet.fullName || selectedBet.username
              }}</span>
              <feather-icon
                icon="CopyIcon"
                size="13"
                class="text-muted"
                style="cursor: pointer"
                @click="copyUserId"
              />
              <feather-icon
                icon="ExternalLinkIcon"
                size="13"
                class="text-muted"
                style="cursor: pointer"
                @click="openCustomerPage"
              />
              <span
                style="
                  width: 9px;
                  height: 9px;
                  border-radius: 50%;
                  background: #3b82f6;
                  display: inline-block;
                "
              ></span>
              <span
                style="
                  width: 9px;
                  height: 9px;
                  border-radius: 50%;
                  background: #ef4444;
                  display: inline-block;
                "
              ></span>
            </div>
            <!-- <div style="font-size: 11px; color: #6b7280">
              AV
              <strong style="color: #1a1a1a">{{
                selectedBet.av != null && selectedBet.av !== 0
                  ? formatCurrencyBuiltInFunc(selectedBet.av)
                  : "N/A"
              }}</strong>
              &nbsp; BETS
              <strong style="color: #1a1a1a">{{
                selectedBet.totalBets != null && selectedBet.totalBets !== 0
                  ? selectedBet.totalBets
                  : "N/A"
              }}</strong>
              &nbsp; W/L
              <strong
                :style="{
                  color:
                    selectedBet.winLoss != null && selectedBet.winLoss !== 0
                      ? selectedBet.winLoss >= 0
                        ? '#16a34a'
                        : '#dc2626'
                      : '#1a1a1a',
                }"
              >
                {{
                  selectedBet.winLoss != null && selectedBet.winLoss !== 0
                    ? formatCurrencyBuiltInFunc(selectedBet.winLoss)
                    : "N/A"
                }}
              </strong>
              &nbsp; ROI
              <strong
                :style="{
                  color:
                    selectedBet.roi != null && selectedBet.roi !== 0
                      ? selectedBet.roi >= 0
                        ? '#16a34a'
                        : '#dc2626'
                      : '#1a1a1a',
                }"
              >
                {{
                  selectedBet.roi != null && selectedBet.roi !== 0
                    ? selectedBet.roi + "%"
                    : "N/A"
                }}
              </strong>
            </div> -->
          </div>
        </div>

        <!-- Selections -->
        <div
          style="
            max-height: 360px;
            overflow-y: auto;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            margin-bottom: 14px;
          "
        >
          <!-- Bet Date + Status + ID (in box) -->
          <div style="padding: 10px 12px">
            <div class="d-flex flex-wrap justify-content-between align-items-start">
              <div>
                <div style="font-size: 13px; font-weight: 600">
                  {{
                    selectedBet.createdTime
                      ? format(
                          new Date(selectedBet.createdTime),
                          "yyyy-MM-dd hh:mm:ss aa"
                        )
                      : "-"
                  }}
                </div>
                <div
                  style="
                    font-size: 10px;
                    color: #9ca3af;
                    word-break: break-all;
                    margin-top: 2px;
                  "
                >
                  {{ selectedBet.displayId }}
                </div>
              </div>
              <div class="text-right" style="flex-shrink: 0; margin-left: 12px">
                <b-badge
                  :variant="resultBadgeVariant(selectedBet.result)"
                  class="text-capitalize"
                  >{{ resultLabel(selectedBet.result) }}</b-badge
                >
                <div style="font-size: 11px; font-weight: 600; color: #1a1a1a">
                  {{ getBetTypeLabel(selectedBet) }}
                </div>
              </div>
            </div>
          </div>

          <!-- All results finalized (BM bets only) -->
          <div
            v-if="selectedBet.acceptanceSource === 'bm'"
            style="padding: 6px 12px; border-top: 1px solid #e5e7eb; background: #f9fafb"
          >
            <b-form-checkbox
              :checked="localFinalManualSet"
              :disabled="Boolean(selectedBet.isFinalManualSet) || finalizingResults"
              @change="val => { localFinalManualSet = val; if (val) onCheckboxFinalizeResults(); }"
            >
              <span style="font-size: 12px; font-weight: 500">All results finalized</span>
            </b-form-checkbox>
          </div>

          <!-- SINGLE / MULTI / SRM / COMBO -->
          <template
            v-if="
              ['single', 'multi', 'combo-racing', 'sgm'].includes(
                selectedBet.type
              )
            "
          >
            <template
              v-for="(item, ind) in processedSelections"
            >
              <!-- SGM Group -->
              <div
                v-if="item.isSgm"
                :key="'sgm-' + ind"
                style="padding: 10px 12px; border-top: 1px solid #e5e7eb"
              >
                <!-- Group header: label + odds + result badge | button -->
                <div
                  class="d-flex align-items-start justify-content-between"
                  style="margin-bottom: 8px; gap: 8px"
                >
                  <div>
                    <div class="d-flex align-items-center" style="gap: 6px; flex-wrap: wrap; margin-bottom: 4px">
                      <span style="font-weight: 700; font-size: 13px; background: #f3f4f6; padding: 2px 8px; border-radius: 4px">Same Game Multi</span>
                      <span style="font-size: 12px; color: #6b7280">@<strong style="color: #1a1a1a">{{ item.odds != null ? Number(item.odds).toFixed(2) : 'N/A' }}</strong></span>
                    </div>
                    <b-badge :variant="resultBadgeVariant(item.result)" style="font-size: 10px">
                      {{ resultLabel(item.result) }}
                    </b-badge>
                  </div>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    style="font-size: 10px; min-width: 130px; flex-shrink: 0"
                    @click="selectedBet.acceptanceSource === 'bm'
                      ? openBmResultModal(item.selections, true, item.result, item.groupBetId, item.odds)
                      : openSgmManualResult(item)"
                  >Manual Result SGM</b-button>
                </div>

                <!-- SGM legs -->
                <div style="border-left: 3px solid #e5e7eb; padding-left: 10px">
                  <div
                    v-for="(sel, sInd) in item.selections"
                    :key="sel.id || sInd"
                    :style="{
                      paddingBottom: sInd < item.selections.length - 1 ? '8px' : '0',
                      marginBottom: sInd < item.selections.length - 1 ? '8px' : '0',
                      borderBottom: sInd < item.selections.length - 1 ? '1px dashed #e5e7eb' : 'none',
                    }"
                  >
                    <div class="d-flex justify-content-between align-items-start" style="gap: 8px">
                      <!-- Left: info -->
                      <div style="flex: 1; min-width: 0">
                        <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 2px; gap: 6px">
                          <span style="font-weight: 700; font-size: 12px">{{ getSportLabel(sel) }}</span>
                          <countdown-badge
                            v-if="!sel.finalStatus || ['OPEN', 'REOPEN'].includes(sel.finalStatus)"
                            :start-time="sel.raceStartTime || sel.eventStartTime"
                          />
                        </div>
                        <div v-if="sel.raceStartTime || sel.eventStartTime" style="font-size: 11px; color: #6b7280; margin-bottom: 2px">
                          {{ format(new Date(sel.raceStartTime || sel.eventStartTime), "EEEE, d MMMM yyyy hh:mm aa") }}
                        </div>
                        <div v-if="sel.eventTitle" style="font-size: 12px; color: #374151; margin-bottom: 2px">
                          {{ sel.eventTitle }}
                        </div>
                        <div style="font-size: 12px; color: #374151">
                          {{ sel.marketName ? sel.marketName + ' — ' : '' }}{{ sel.name }}
                          @<strong style="color: #111827">{{ sel.odds != null && sel.odds !== 0 ? Number(sel.odds).toFixed(2) : 'N/A' }}</strong>
                        </div>
                      </div>
                      <!-- Right: result badge + action -->
                      <div class="d-flex flex-column align-items-end" style="gap: 4px; flex-shrink: 0">
                        <b-badge :variant="sel.result ? resultVariant(sel.result) : 'light-secondary'" style="font-size: 10px">
                          {{ resultLabel(sel.result) }}
                        </b-badge>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          style="font-size: 10px; min-width: 98px"
                          v-if="selectedBet.acceptanceSource !== 'bm'"
                          @click="selectedBet.acceptanceSource === 'bm'
                            ? openBmResultModal([sel])
                            : openModalUpdateResultSelection(sel)"
                        >Manual Result</b-button>
                        <b-button
                          v-if="canVoidSelection(sel)"
                          size="sm"
                          variant="outline-danger"
                          style="font-size: 10px; min-width: 98px"
                          :disabled="loadingVoidSelections"
                          @click="handleVoidSelection(sel)"
                        >Void Selection</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SRM Group -->
              <div
                v-else-if="item.isSrm"
                :key="'srm-' + ind"
                style="padding: 10px 12px; border-top: 1px solid #e5e7eb"
              >
                <!-- Header: checkbox + badge + odds -->
                <div
                  class="d-flex align-items-center"
                  style="margin-bottom: 6px; gap: 8px"
                >
                  <!-- <b-form-checkbox
                    v-if="selectedBet.status !== 'declined'"
                    v-model="cancelledLegs"
                    :value="item.raceId || (item.selections[0] && item.selections[0].id)"
                    style="margin: 0; flex-shrink: 0"
                  /> -->
                  <span
                    style="
                      font-weight: 700;
                      font-size: 13px;
                      background: #f3f4f6;
                      padding: 2px 8px;
                      border-radius: 4px;
                    "
                  >Same Race Multi</span>
                  <b-button
                    v-if="parseCombos(item).length > 1"
                    variant="link"
                    size="sm"
                    class="p-0"
                    @click="openComboModal(item)"
                  >
                    Show Combos
                  </b-button>
                  <span
                    style="font-size: 12px; color: #6b7280"
                  >@<strong style="color: #1a1a1a">{{ item.odds != null ? Number(item.odds).toFixed(2) : 'N/A' }}</strong></span>
                </div>

                <!-- Race info + countdown -->
                <div
                  v-if="item.selections[0] && item.selections[0].meetingName && item.selections[0].raceNumber"
                  class="d-flex justify-content-between align-items-center"
                  style="margin-bottom: 2px; gap: 8px"
                >
                  <span style="font-size: 12px; color: #374151; font-weight: 600">
                    Race {{ item.selections[0].raceNumber }} - {{ item.selections[0].meetingName }}
                  </span>
                  <countdown-badge
                    v-if="
                      item.selections[0] &&
                      (!item.selections[0].finalStatus ||
                        ['OPEN', 'REOPEN'].includes(item.selections[0].finalStatus))
                    "
                    :start-time="item.selections[0].raceStartTime || item.selections[0].eventStartTime"
                  />
                </div>

                <!-- Date/time row -->
                <div
                  v-if="item.selections[0] && (item.selections[0].raceStartTime || item.selections[0].eventStartTime)"
                  style="font-size: 11px; color: #6b7280; margin-bottom: 8px"
                >
                  {{
                    format(
                      new Date(item.selections[0].raceStartTime || item.selections[0].eventStartTime),
                      "EEEE, d MMMM yyyy hh:mm aa"
                    )
                  }}
                </div>

                <!-- Positions 1..4 -->
                <div v-for="i in 4" :key="'pos-' + i">
                  <div
                    v-if="item.selections.filter((s) => s[`place${i}`] === 1).length"
                    style="margin-bottom: 6px"
                  >
                    <div
                      style="
                        font-size: 12px;
                        font-weight: 600;
                        color: #374151;
                        margin-bottom: 4px;
                      "
                    >
                      Position: {{ i }}
                    </div>
                    <div
                      v-for="sel in item.selections.filter((s) => s[`place${i}`] === 1)"
                      :key="sel.id"
                      class="d-flex align-items-center"
                      style="gap: 6px; margin-bottom: 3px; padding-left: 4px"
                    >
                      <img
                        v-if="sel.silkStrip"
                        :src="sel.silkStrip"
                        style="width: 20px; height: 20px; object-fit: cover; display: block"
                        :style="{
                          objectPosition: sel.runnerNo
                            ? `-${20 * (sel.runnerNo - 1)}px 0`
                            : '0',
                        }"
                      />
                      <div
                        v-else
                        style="
                          width: 20px;
                          height: 20px;
                          background: #e5e7eb;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          font-size: 9px;
                          font-weight: 700;
                          color: #374151;
                        "
                      >
                        {{ sel.runnerNo }}
                      </div>
                      <span style="font-size: 12px; color: #111827">
                        {{ sel.runnerNo }}. {{ sel.runnerName }}{{
                          sel.barrierPosition ? ` (${sel.barrierPosition})` : ""
                        }}
                      </span>
                      <b-button
                        v-if="canScratchRunner(sel)"
                        size="sm"
                        variant="outline-warning"
                        class="ml-auto"
                        style="font-size: 10px; padding: 1px 6px; flex-shrink: 0"
                        :disabled="togglingScratchRunnerId === getRunnerId(sel)"
                        @click="handleScratchRunner(sel, item.raceId)"
                      >Scratch</b-button>
                      <div
                        v-if="sel.raceStatus === 'RESULT'"
                        class="d-flex align-items-center justify-content-center"
                        :style="{
                          background:
                            checkResultBetTypeCombo(sel, { ...selectedBet, type: 'srm' }, i) === 'Lose'
                              ? '#B00606'
                              : '#007800',
                          borderRadius: '100%',
                          width: '20px',
                          height: '20px',
                          flexShrink: 0,
                          rotate:
                            checkResultBetTypeCombo(sel, { ...selectedBet, type: 'srm' }, i) === 'Lose'
                              ? '180deg'
                              : '0deg',
                        }"
                      >
                        <img
                          class="d-block img-fluid"
                          width="12"
                          height="12"
                          :src="require('@/assets/images/icons/thumb-icon.svg')"
                          alt="thumb-icon"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Manual Result -->
                <div class="d-flex justify-content-end" style="margin-top: 6px; gap: 6px">
                  <b-button
                    v-if="canAbandonRace(item.raceId, item.selections[0])"
                    size="sm"
                    variant="outline-danger"
                    style="font-size: 10px; min-width: 98px"
                    :disabled="abandoningRaceId === item.raceId"
                    @click="handleAbandonRace(item.raceId, item.selections[0])"
                  >Abandon Race</b-button>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    style="font-size: 10px; min-width: 98px"
                    @click="selectedBet.acceptanceSource === 'bm'
                      ? openBmResultModal(item.selections)
                      : openManualResult(item.raceId, item.racingType || (item.selections && item.selections[0] && item.selections[0].racingType))"
                  >Manual Result</b-button>
                </div>
              </div>

              <!-- Regular selection -->
              <div
                v-else
                :key="'sel-' + ind"
                style="padding: 10px 12px; border-top: 1px solid #e5e7eb"
              >
                <div class="d-flex justify-content-between align-items-start" style="gap: 8px">
                  <!-- Left: info -->
                  <div style="flex: 1; min-width: 0">
                    <!-- Row 1: sport label -->
                    <div style="font-weight: 700; font-size: 13px; margin-bottom: 2px">
                      {{ getSportLabel(item) }}
                    </div>
                    <!-- Row 2: date/time -->
                    <div v-if="item.raceStartTime || item.eventStartTime" style="font-size: 11px; color: #6b7280; margin-bottom: 2px">
                      {{ format(new Date(item.raceStartTime || item.eventStartTime), "EEEE, d MMMM yyyy hh:mm aa") }}
                    </div>
                    <!-- Row 3: race/event name -->
                    <div v-if="item.raceId" style="font-size: 12px; color: #374151; margin-bottom: 2px">
                      Race {{ item.raceNumber ? item.raceNumber : item.eventName }} — {{ item.meetingName }}
                    </div>
                    <div v-else-if="item.eventTitle" style="font-size: 12px; color: #374151; margin-bottom: 2px">
                      {{ item.eventTitle }}
                    </div>
                    <!-- Row 4: selection details + odds -->
                    <div style="font-size: 12px; color: #374151">
                      <template v-if="item.raceId">
                        {{ convertSelectionType(item) }} — {{ item.runnerNo ? item.runnerNo + '.' : "" }} {{ item.runnerName }}{{ item.barrierPosition ? ` (${item.barrierPosition})` : '' }}
                        @<strong style="color: #111827">{{ item.odds != null && item.odds !== 0 ? Number(item.odds).toFixed(2) : 'N/A' }}</strong>
                      </template>
                      <template v-else-if="item.eventTitle">
                        {{ item.marketName ? item.marketName + ' — ' : '' }}{{ item.name }}
                        @<strong style="color: #111827">{{ item.odds != null && item.odds !== 0 ? Number(item.odds).toFixed(2) : 'N/A' }}</strong>
                      </template>
                    </div>
                  </div>
                  <!-- Right: timer + result badge + action -->
                  <div class="d-flex flex-column align-items-end" style="gap: 4px; flex-shrink: 0">
                    <countdown-badge
                      v-if="!item.finalStatus || ['OPEN', 'REOPEN'].includes(item.finalStatus)"
                      :start-time="item.raceStartTime || item.eventStartTime"
                    />
                    <b-badge :variant="item.status === 'cancelled' ? 'light-danger' : item.result ? resultVariant(item.result) : 'light-secondary'" style="font-size: 10px">
                      {{ item.status === 'cancelled' ? 'VOID' : resultLabel(item.result) }}
                    </b-badge>
                    <b-button
                      v-if="item.raceId && item.status !== 'cancelled'"
                      size="sm"
                      variant="outline-primary"
                      style="font-size: 10px; min-width: 98px"
                      @click="selectedBet.acceptanceSource === 'bm'
                        ? openBmResultModal([item])
                        : openManualResult(item.raceId, item.racingType || (item.selections && item.selections[0] && item.selections[0].racingType))"
                    >Manual Result</b-button>
                    <b-button
                      v-if="canAbandonRace(item.raceId, item)"
                      size="sm"
                      variant="outline-danger"
                      style="font-size: 10px; min-width: 98px"
                      :disabled="abandoningRaceId === item.raceId"
                      @click="handleAbandonRace(item.raceId, item)"
                    >Abandon Race</b-button>
                    <b-button
                      v-if="item.raceId && canScratchRunner(item)"
                      size="sm"
                      variant="outline-warning"
                      style="font-size: 10px; min-width: 98px"
                      :disabled="togglingScratchRunnerId === getRunnerId(item)"
                      @click="handleScratchRunner(item)"
                    >Scratch</b-button>
                    <b-button
                      v-else-if="item.eventTitle && item.status !== 'cancelled'"
                      size="sm"
                      variant="outline-primary"
                      style="font-size: 10px; min-width: 98px"
                      @click="selectedBet.acceptanceSource === 'bm'
                        ? openBmResultModal([item])
                        : openModalUpdateResultSelection(item)"
                    >Manual Result</b-button>
                    <b-button
                      v-if="canVoidSelection(item)"
                      size="sm"
                      variant="outline-danger"
                      style="font-size: 10px; min-width: 98px"
                      :disabled="loadingVoidSelections"
                      @click="handleVoidSelection(item)"
                    >Void Selection</b-button>
                  </div>
                </div>
              </div>
            </template>
          </template>

          <!-- EXOTIC (trifecta, quinella, first4, exacta, srm) -->
          <template v-else-if="isExoticBetType(selectedBet.type) && selectedBet.selections && selectedBet.selections.length">
            <div style="padding: 10px 12px; border-top: 1px solid #e5e7eb">
              <!-- Race header row: checkbox + name + link + timer -->
              <div
                class="d-flex align-items-center"
                style="gap: 8px; margin-bottom: 4px"
              >
                <!-- <b-form-checkbox
                  v-if="selectedBet.status !== 'declined'"
                  v-model="cancelledLegs"
                  :value="
                    selectedBet.selections[0]
                      ? selectedBet.selections[0].raceId
                      : null
                  "
                  style="margin: 0; flex-shrink: 0"
                /> -->
                <div
                  class="d-flex align-items-center justify-content-between"
                  style="flex: 1; min-width: 0"
                >
                  <div class="d-flex align-items-center" style="gap: 5px">
                    <span style="font-weight: 700; font-size: 13px">{{
                      selectedBet.selections[0]
                        ? `${selectedBet.selections[0].meetingName} R${selectedBet.selections[0].raceNumber}`
                        : ""
                    }}</span>
                  </div>
                  <countdown-badge
                    v-if="
                      selectedBet.selections[0] &&
                      (!selectedBet.selections[0].finalStatus ||
                        ['OPEN', 'REOPEN'].includes(
                          selectedBet.selections[0].finalStatus
                        ))
                    "
                    :start-time="
                      selectedBet.selections[0].raceStartTime ||
                      selectedBet.selections[0].eventStartTime
                    "
                  />
                </div>
              </div>

              <!-- Date/time row -->
              <div
                v-if="
                  selectedBet.selections[0] &&
                  (selectedBet.selections[0].raceStartTime ||
                    selectedBet.selections[0].eventStartTime)
                "
                style="
                  font-size: 11px;
                  color: #6b7280;
                  margin-bottom: 8px;
                  padding-left: 24px;
                "
              >
                {{
                  format(
                    new Date(
                      selectedBet.selections[0].raceStartTime ||
                        selectedBet.selections[0].eventStartTime
                    ),
                    "EEEE, d MMMM yyyy hh:mm aa"
                  )
                }}
              </div>

              <!-- Positions -->
              <div v-for="i in 4" :key="i">
                <div
                  v-if="
                    selectedBet.selections.filter((s) => s[`place${i}`] === 1)
                      .length
                  "
                  :style="{ marginBottom: '6px' }"
                >
                  <div
                    style="
                      font-size: 12px;
                      font-weight: 600;
                      color: #374151;
                      margin-bottom: 4px;
                    "
                  >
                    Position: {{ i }}
                  </div>
                  <div
                    v-for="sel in selectedBet.selections.filter(
                      (s) => s[`place${i}`] === 1
                    )"
                    :key="sel.id"
                    class="d-flex align-items-center"
                    style="gap: 6px; margin-bottom: 3px; padding-left: 4px"
                  >
                    <!-- Silk badge -->

                    <img
                      v-if="sel.silkStrip"
                      :src="sel.silkStrip"
                      style="
                        width: 20px;
                        height: 20px;
                        object-fit: cover;
                        display: block;
                      "
                      :style="{
                        objectPosition: sel.runnerNo
                          ? `-${20 * (sel.runnerNo - 1)}px 0`
                          : '0',
                      }"
                    />
                    <div
                      v-else
                      style="
                        width: 20px;
                        height: 20px;
                        background: #e5e7eb;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 9px;
                        font-weight: 700;
                        color: #374151;
                      "
                    >
                      {{ sel.runnerNo }}
                    </div>
                    <span style="font-size: 12px; color: #111827"
                      >{{ sel.runnerNo }}. {{ sel.runnerName
                      }}{{
                        sel.barrierPosition ? ` (${sel.barrierPosition})` : ""
                      }}</span
                    >
                    <!-- Resultable non-BM bets cancel the runner for this bet only -->
                    <template v-if="canManualResultBet(selectedBet)">
                      <b-badge
                        v-if="sel.status === 'cancelled'"
                        variant="light-secondary"
                        class="ml-auto"
                        style="font-size: 10px; flex-shrink: 0"
                      >Cancelled</b-badge>
                      <b-button
                        v-else
                        size="sm"
                        variant="outline-warning"
                        class="ml-auto"
                        style="font-size: 10px; padding: 1px 6px; flex-shrink: 0"
                        :disabled="cancellingLegId === sel.id"
                        @click="handleCancelExoticRunner(sel)"
                      >Cancel</b-button>
                    </template>
                    <b-button
                      v-else-if="canScratchRunner(sel)"
                      size="sm"
                      variant="outline-warning"
                      class="ml-auto"
                      style="font-size: 10px; padding: 1px 6px; flex-shrink: 0"
                      :disabled="togglingScratchRunnerId === getRunnerId(sel)"
                      @click="handleScratchRunner(sel)"
                    >Scratch</b-button>
                    <div
                      v-if="sel.raceStatus === 'RESULT'"
                      class="d-flex align-items-center justify-content-center"
                      :style="{
                        background:
                          checkResultBetTypeCombo(sel, selectedBet, i) === 'Lose'
                            ? '#B00606'
                            : '#007800',
                        borderRadius: '100%',
                        width: '20px',
                        height: '20px',
                        flexShrink: 0,
                        rotate:
                          checkResultBetTypeCombo(sel, selectedBet, i) === 'Lose'
                            ? '180deg'
                            : '0deg',
                      }"
                    >
                      <img
                        class="d-block img-fluid"
                        width="12"
                        height="12"
                        :src="require('@/assets/images/icons/thumb-icon.svg')"
                        alt="thumb-icon"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Manual Result -->
              <div class="d-flex justify-content-end" style="margin-top: 6px; gap: 6px">
                <b-button
                  v-if="canAbandonRace(selectedBet.selections[0].raceId, selectedBet.selections[0])"
                  size="sm"
                  variant="outline-danger"
                  style="font-size: 10px; min-width: 98px"
                  :disabled="abandoningRaceId === selectedBet.selections[0].raceId"
                  @click="handleAbandonRace(selectedBet.selections[0].raceId, selectedBet.selections[0])"
                >Abandon Race</b-button>
                <!-- Non-BM exotic bets use "Manual Result Bet" instead -->
                <b-button
                  v-if="selectedBet.acceptanceSource === 'bm'"
                  size="sm"
                  variant="outline-primary"
                  style="font-size: 10px; min-width: 98px"
                  @click="selectedBet.acceptanceSource === 'bm'
                    ? openBmResultModal(selectedBet.selections)
                    : openManualResult(selectedBet.selections[0].raceId, selectedBet.selections[0].racingType)"
                >Manual Result</b-button>
              </div>
            </div>
          </template>

          <!-- OTHER (quaddie, treble, running-double, daily-double) -->
          <template v-else>
            <div
              v-for="(race, index) in groupedSelections"
              :key="index"
              :style="{
                padding: '10px 12px',
                borderTop: index > 0 ? '1px solid #e5e7eb' : 'none',
              }"
            >
              <div
                class="d-flex justify-content-between align-items-center"
                style="margin-bottom: 6px"
              >
                <span style="font-size: 13px; font-weight: 700"
                  >Race {{ race.raceNumber }} - {{ race.meetingName }}</span
                >
                <countdown-badge
                  v-if="
                    race.raceStartTime &&
                    (!race.finalStatus ||
                      ['OPEN', 'REOPEN'].includes(race.finalStatus))
                  "
                  :start-time="race.raceStartTime"
                />
                <small v-else-if="race.raceStartTime" class="text-muted">{{
                  format(new Date(race.raceStartTime), "dd/MM/yyyy HH:mm")
                }}</small>
              </div>
              <div
                v-if="canAbandonRace(race.raceId, race)"
                class="d-flex justify-content-end"
                style="margin-bottom: 6px"
              >
                <b-button
                                  size="sm"
                  variant="outline-danger"
                  style="font-size: 10px; min-width: 98px"
                  :disabled="abandoningRaceId === race.raceId"
                  @click="handleAbandonRace(race.raceId, race)"
                >Abandon Race</b-button>
              </div>
              <div
                v-for="sel in race.selections"
                :key="sel.id"
                class="d-flex align-items-center"
                style="gap: 8px; padding: 3px 0"
              >
                <img
                  v-if="sel.silkStrip"
                  style="
                    width: 28px;
                    height: 28px;
                    object-fit: cover;
                    border-radius: 4px;
                  "
                  :src="sel.silkStrip"
                  :style="{
                    objectPosition: sel.runnerNo
                      ? `-${28 * (sel.runnerNo - 1)}px 0`
                      : '0',
                  }"
                />
                <span style="font-size: 12px; font-weight: 600; flex: 1"
                  >{{ sel.runnerNo }}. {{ sel.runnerName
                  }}{{
                    sel.barrierPosition ? ` (${sel.barrierPosition})` : ""
                  }}</span
                >
                <b-button
                  v-if="canScratchRunner(sel)"
                  size="sm"
                  variant="outline-warning"
                  class="ml-auto"
                  style="font-size: 10px; padding: 1px 6px; flex-shrink: 0"
                  :disabled="togglingScratchRunnerId === getRunnerId(sel)"
                  @click="handleScratchRunner(sel)"
                >Scratch</b-button>
              </div>
            </div>
          </template>
        </div>

        <!-- Footer info -->
        <div class="d-flex flex-wrap justify-content-between" style="margin-bottom: 12px">
          <div>
            <div style="font-size: 12px; color: #6b7280">
              Liability:
              <strong style="color: #1a1a1a">{{ liabilityDisplay }}</strong>
            </div>
            <div
              v-if="selectedBet.status !== 'resulted'"
              style="font-size: 12px; color: #6b7280"
            >
              Potential Return:
              <strong style="color: #1a1a1a">{{ potentialReturn }}</strong>
            </div>
            <div
              v-if="selectedBet.status == 'resulted'"
              style="font-size: 12px; color: #6b7280"
            >
              Result:
              <strong style="color: #1a1a1a">{{
                selectedBet.totalPayout
                  ? formatCurrencyBuiltInFunc(selectedBet.totalPayout)
                  : "No Return"
              }}</strong>
            </div>
          </div>
          <div class="text-md-right">
             <div
              v-if="selectedBet.combos"
              style="font-size: 12px; color: #6b7280"
            >
              Combos:
              <strong style="color: #1a1a1a"
                >{{ selectedBet.combos }}</strong
              >
            </div>
            <div
              v-if="selectedBet.fractionalPercent"
              style="font-size: 12px; color: #6b7280"
            >
              Per Combo Stake:
              <strong style="color: #1a1a1a"
                >${{ (selectedBet.fractionalPercent/100).toFixed(2) }}</strong
              >
            </div>
            <div
              v-if="selectedBet.fractionalPercent"
              style="font-size: 12px; color: #6b7280"
            >
              Percentage:
              <strong style="color: #1a1a1a"
                >{{ selectedBet.fractionalPercent.toFixed(0) }}%</strong
              >
            </div>
            <div
              v-if="selectedBet.odds"
              style="font-size: 12px; color: #6b7280"
            >
              Odds:
              <strong style="color: #1a1a1a">{{
                Number(selectedBet.odds).toFixed(2)
              }}</strong>
            </div>
            <div style="font-size: 12px; color: #6b7280">
              {{ selectedBet.currencyMethod === "bonus" ? "Bonus " : "Stake" }}:

              <strong style="color: #1a1a1a">{{
                selectedBet.stake != null && selectedBet.stake !== 0
                  ? selectedBet.currencyMethod === "bonus"
                    ? selectedBet.stake.toFixed(2)
                    : formatCurrencyBuiltInFunc(selectedBet.stake)
                  : "N/A"
              }}</strong>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex flex-wrap" style="gap: 8px">
          <b-button
            variant="outline-secondary"
            class="flex-grow-1"
            @click="selectedBet.acceptanceSource === 'bm' ? showBmAmendModal = true : openModalAmendBet()"
            style="border-radius: 6px; font-size: 13px; font-weight: 500"
            >Amend Bet</b-button
          >
          <b-button
            v-if="canManualResultBet(selectedBet)"
            variant="outline-warning"
            class="flex-grow-1"
            style="border-radius: 6px; font-size: 13px; font-weight: 500"
            @click="openBetManualResult"
            >Manual Result Bet</b-button
          >
          <b-button
            v-if="selectedBet.status === 'pending'"
            variant="outline-primary"
            class="flex-grow-1"
            style="border-radius: 6px; font-size: 13px; font-weight: 500"
            @click="showModal('approve-bet')"
            >Approve Bet</b-button
          >
          <b-button
            v-if="selectedBet.status !== 'declined'"
            class="flex-grow-1"
            style="
              background: #111827;
              border: none;
              border-radius: 6px;
              font-size: 13px;
              font-weight: 500;
              color: white;
            "
            @click="showModal('cancel-bet')"
            >Cancel Bet</b-button
          >
        </div>
      </div>
    </b-modal>

    <!-- Amend Bet Modal -->
    <b-modal id="amend-bet" ref="amendModal" centered>
      <template #modal-title>Amend Bet</template>

      <div v-if="editBet" class="text-body">
        <p class="text-muted">
          Update the stake and odds for this bet. The liability will be
          automatically calculated.
        </p>

        <b-row>
          <b-col
            ><p><strong>Bet ID:</strong><br />{{ editBet.displayId }}</p></b-col
          >
          <b-col
            ><p>
              <strong>Customer:</strong><br />{{ editBet.username }}
            </p></b-col
          >
        </b-row>

        <!-- <b-form-group v-if="editBet.type === 'sgm'" label="Status">
          <b-form-select
            v-model="editBet.result"
            :options="resultBetOptions"
          ></b-form-select>
        </b-form-group> -->

        <b-form-group label="Stake ($)">
          <b-form-input
            v-model.number="editBet.newStake"
            :disabled="
              editBet.status === 'transferred' || editBet.status === 'approved'
            "
          ></b-form-input>
        </b-form-group>

        <template v-if="!isComboBetType(editBet.type)">
          <template v-if="editBet.type === 'sgm'">
            <b-form-group v-if="editBet.sgmGroups && editBet.sgmGroups[0]" label="Odds">
              <b-form-input
                v-model.number="editBet.sgmGroups[0].newOdds"
                :disabled="
                  editBet.status === 'transferred' ||
                  editBet.status === 'approved'
                "
              ></b-form-input>
            </b-form-group>
          </template>
          <template v-else-if="editBet.type === 'multi'">
            <b-form-group
              :label="`Odds - Leg ${index + 1}`"
              v-for="(sel, index) in editBet.selections"
              :key="'sel-' + index"
            >
              <b-form-input
                v-model.number="sel.newOdds"
                :disabled="
                  editBet.status === 'transferred' ||
                  editBet.status === 'approved'
                "
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-for="(sgm, sIndex) in editBet.sgmGroups"
              :key="'sgm-' + sIndex"
              :label="`Odds - Same Game Multi ${editBet.sgmGroups.length > 1 ? sIndex + 1 : ''}`"
            >
              <b-form-input
                v-model.number="sgm.newOdds"
                :disabled="
                  editBet.status === 'transferred' ||
                  editBet.status === 'approved'
                "
              ></b-form-input>
            </b-form-group>
            <b-form-group
              v-for="(srm, srmIndex) in editBet.srmGroups"
              :key="'srm-' + srmIndex"
              :label="`Odds - Same Race Multi ${editBet.srmGroups.length > 1 ? srmIndex + 1 : ''}`"
            >
              <b-form-input
                v-model.number="srm.newOdds"
                :disabled="
                  editBet.status === 'transferred' ||
                  editBet.status === 'approved'
                "
              ></b-form-input>
            </b-form-group>
          </template>
          <b-form-group label="Odds" v-else-if="editBet.selections && editBet.selections[0]">
            <b-form-input
              v-model.number="editBet.selections[0].newOdds"
              :disabled="
                editBet.status === 'transferred' ||
                editBet.status === 'approved'
              "
            ></b-form-input>
          </b-form-group>
        </template>

        <div
          class="bg-light p-1 mt-1 rounded d-flex justify-content-between"
          style="gap: 10px"
        >
          <p class="mb-0 text-muted">Liability:</p>
          <p class="mb-0 font-weight-bolder text-right">
            {{
              editAmendOdds <= 0
                ? "N/A"
                : formatCurrencyBuiltInFunc(
                    editBet.newStake * editAmendOdds - editBet.newStake
                  )
            }}
          </p>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex">
          <b-button
            variant="secondary"
            class="w-100 mr-2"
            @click="closeModalAmendBet"
            >Cancel</b-button
          >
          <b-button variant="primary" class="w-100" @click="handleSaveAmendBet"
            >Save Changes</b-button
          >
        </div>
      </template>
    </b-modal>

    <!-- MODAL CONFIRM -->
    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isLoading"
      @ok="handleSubmitModal"
    >
      <b-card-text style="color: black">{{ modal.content }}</b-card-text>
      <template #modal-ok>
        <Spinner v-if="isLoading" />
        <span v-else>Submit</span>
      </template>
    </b-modal>

    <!-- MODAL UPDATE RESULT -->
    <UpdateResultModal
      ref="resultModal"
      :activeSelection="selectedSelection"
      @hideResult="hideModalEditResult"
    />
    <ManualResultModal :raceId="selectedRaceId" modal-id="betslip-manual-result-modal" @success="$emit('refresh')" :is-future="selectedRacingType === 'future'" />
    <SgmManualResultModal
      ref="sgmManualResultModal"
      :selectedBet="selectedBet"
      @success="onSgmResultSuccess"
    />
    <BetslipManualResultModal
      ref="betslipManualResultModal"
      @success="onSgmResultSuccess"
    />
    <BmManualResultModal
      v-model="showBmResultModal"
      :selections="bmResultSelections"
      :with-sgm-result="bmIsSgm"
      :initial-sgm-result="bmSgmGroupResult"
      :is-exotic="bmIsExotic"
      :betslip-id="selectedBet ? selectedBet.displayId || selectedBet.id : null"
      :group-odds="bmSgmGroupOdds"
      @save="onBmResultSave"
    />
    <!-- <BmAmendResultModal
      v-model="showBmAmendModal"
      :loading="loadingUpdateStakeOddsBetslip"
      :initial-result="selectedBet ? selectedBet.result : null"
      :initial-odds="selectedBet ? selectedBet.odds : null"
      :initial-payout="selectedBet ? selectedBet.totalPayout : null"
      @save="onBmAmendSave"
    /> -->

    <b-modal
      v-model="showComboModal"
      title="SRM Combos"
      size="md"
      centered
      ok-only
      ok-title="Close"
      ok-variant="secondary"
    >
      <div
        v-if="currentCombos.length === 0"
        class="text-center py-2"
      >
        No combos found.
      </div>
      <div
        v-else
        class="border rounded overflow-hidden"
        style="font-size: 0.9rem;"
      >
        <div
          class="font-weight-bold"
          :style="{
            display: 'grid',
            gridTemplateColumns: comboGridCols,
            columnGap: '4px',
            padding: '4px 8px',
            backgroundColor: '#E5E7EB',
          }"
        >
          <span class="text-center">Combo</span>
          <span v-if="comboColumnsShown.win" class="text-center">Win</span>
          <span v-if="comboColumnsShown.top2" class="text-center">Top2</span>
          <span v-if="comboColumnsShown.top3" class="text-center">Top3</span>
          <span v-if="comboColumnsShown.top4" class="text-center">Top4</span>
          <span class="text-right">Odds</span>
          <span class="text-center">Result</span>
        </div>
        <div style="max-height: 320px; overflow-y: auto;">
          <div
            v-for="(combo, index) in currentCombos"
            :key="index"
            :style="{
              display: 'grid',
              gridTemplateColumns: comboGridCols,
              columnGap: '4px',
              padding: '4px 8px',
              borderBottom: '1px solid #f1f1f1',
              backgroundColor: combo.result === 'Win' ? '#D1FAE5' : 'transparent',
              fontWeight: combo.result === 'Win' ? 600 : 400,
              color: combo.result === 'Win' ? '#065F46' : 'inherit',
            }"
          >
            <span
              class="text-center"
              :style="{
                backgroundColor: combo.result === 'Win' ? '#A7F3D0' : '#E5E7EB',
                margin: '-4px 0 -4px -8px',
                padding: '4px 0 4px 8px',
              }"
            >
              ({{ index + 1 }})
            </span>
            <span v-if="comboColumnsShown.win" class="text-center">
              {{ combo.Win ? combo.Win.join(", ") : "" }}
            </span>
            <span v-if="comboColumnsShown.top2" class="text-center">
              {{ combo.Top2 ? combo.Top2.join(", ") : "" }}
            </span>
            <span v-if="comboColumnsShown.top3" class="text-center">
              {{ combo.Top3 ? combo.Top3.join(", ") : "" }}
            </span>
            <span v-if="comboColumnsShown.top4" class="text-center">
              {{ combo.Top4 ? combo.Top4.join(", ") : "" }}
            </span>
            <span class="text-right text-nowrap">
              {{ formatOdds(combo.odds) }}
            </span>
            <span class="d-flex align-items-center justify-content-center">
              <div
                v-if="combo.result === 'Win' || combo.result === 'Lose'"
                class="d-flex align-items-center justify-content-center"
                :style="{
                  background: combo.result === 'Lose' ? '#B00606' : '#007800',
                  borderRadius: '100%',
                  width: '20px',
                  height: '20px',
                  flexShrink: 0,
                  rotate: combo.result === 'Lose' ? '180deg' : '0deg',
                }"
              >
                <img
                  class="d-block img-fluid"
                  width="12"
                  height="12"
                  :src="require('@/assets/images/icons/thumb-icon.svg')"
                  alt="thumb-icon"
                />
              </div>
              <span v-else class="text-muted" style="font-size: 0.8rem;">Unresulted</span>
            </span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BBadge,
  BButton,
  BFormSelect,
  BFormInput,
  BModal,
  BFormGroup,
  BCardText,
  BFormCheckbox,
  BAvatar,
} from "bootstrap-vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { mapState, mapActions } from "vuex";
import { debounce } from "debounce";
import { format } from "date-fns";
import useToastHandler from "@/services/toastHandler";
import UpdateResultModal from "./sports/UpdateResultModal.vue";
import ManualResultModal from "./racing/view/modals/ManualResultModal.vue";
import SgmManualResultModal from "./sports/SgmManualResultModal.vue";
import BmManualResultModal from "./sports/BmManualResultModal.vue";
import BetslipManualResultModal from "./manual-result/BetslipManualResultModal.vue";
import {
  canManualResultBet,
  toBetResult,
  buildPreviewConfirmMessage,
} from "./manual-result/utils";
// import BmAmendResultModal from "./sports/BmAmendResultModal.vue";
import { objectProp } from "@/helpers/props";
import Spinner from "@/@core/components/Spinner.vue";

export default {
  components: {
    BCol,
    BRow,
    BBadge,
    BButton,
    BFormSelect,
    BFormInput,
    BModal,
    BFormGroup,
    BCardText,
    BFormCheckbox,
    BAvatar,
    UpdateResultModal,
    ManualResultModal,
    SgmManualResultModal,
    BmManualResultModal,
    BetslipManualResultModal,
    // BmAmendResultModal,
    Spinner,
  },
  props: {
    selectedBet: objectProp(),
  },
  data() {
    return {
      modal: { title: "", content: "" },
      action: { type: "", id: "" },
      resultBetOptions: [
        { value: "resulted-loss", text: "Resulted/Loss" },
        { value: "resulted-win", text: "Resulted/Win" },
        { value: "resulted-draw", text: "Resulted/Draw" },
        { value: "bet-pending", text: "Unresulted" },
      ],
      selectedSelection: null,
      editBet: null,
      cancelledLegs: [],
      selectedRaceId: null,
      selectedRacingType: null,
      showComboModal: false,
      currentCombos: [],
      showBmResultModal: false,
      bmResultSelections: [],
      bmIsSgm: false,
      bmSgmGroupResult: null,
      bmSgmGroupId: null,
      bmSgmGroupOdds: null,
      bmIsExotic: false,
      showBmAmendModal: false,
      finalizingResults: false,
      localFinalManualSet: false,
      togglingScratchRunnerId: null,
      cancellingLegId: null,
      abandoningRaceId: null,
      scratchedRunnerIds: [],
    };
  },
  computed: {
    ...mapState("trading/list", {
      loading: "loadingBetslip",
      pagination: "pagination",
    }),
    ...mapState("trading/betslip", ["loadingUpdateStatusBetslip", "loadingUpdateStakeOddsBetslip", "loadingVoidSelections"]),
    isLoading() {
      return this.loadingUpdateStatusBetslip;
    },
    groupedSelections() {
      if (!this.selectedBet || !this.selectedBet.selections) return [];
      const groups = {};
      this.selectedBet.selections.forEach((sel) => {
        const key = sel.raceId || `${sel.meetingName}-${sel.raceNumber}`;
        if (!groups[key]) {
          groups[key] = {
            raceId: sel.raceId,
            finalStatus: sel.finalStatus,
            raceNumber: sel.raceNumber,
            meetingName: sel.meetingName,
            raceStartTime: sel.raceStartTime,
            selections: [],
          };
        }
        groups[key].selections.push(sel);
      });
      return Object.values(groups).sort(
        (a, b) => new Date(a.raceStartTime) - new Date(b.raceStartTime)
      );
    },
    flattenedSelections() {
      if (!this.selectedBet || !this.selectedBet.selections) return [];
      return this.selectedBet.selections.flatMap((sel) => {
        if (sel.selectionType === "sgm" && Array.isArray(sel.selections)) {
          return sel.selections;
        }
        return [sel];
      });
    },
    processedSelections() {
      if (!this.selectedBet || !this.selectedBet.selections) return [];
      return this.selectedBet.selections.map((sel) => {
        if (sel.selectionType === "sgm" && Array.isArray(sel.selections)) {
          return {
            isSgm: true,
            odds: sel.odds,
            groupBetId: sel.groupBetId,
            result: sel.result,
            selections: sel.selections,
          };
        }
        if (sel.selectionType === "srm" && Array.isArray(sel.selections)) {
          return { isSrm: true, odds: sel.odds, selections: sel.selections, raceId: sel.raceId, selectionsJson: sel.selectionsJson };
        }
        return { isSgm: false, isSrm: false, ...sel };
      });
    },
    avatarInitials() {
      if (!this.selectedBet) return "?";
      const name = this.selectedBet.fullName || this.selectedBet.username || "";
      const parts = name.trim().split(/\s+/);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.slice(0, 2).toUpperCase();
    },
    liabilityDisplay() {
      if (!this.selectedBet) return "N/A";
      // if (!this.selectedBet.odds || !this.selectedBet.stake) return "N/A";
      return formatCurrencyBuiltInFunc(
        this.selectedBet.liability
      );
    },
    potentialReturn() {
      if (!this.selectedBet) return "N/A";
      if (this.selectedBet.totalPayout != null)
        return formatCurrencyBuiltInFunc(this.selectedBet.totalPayout);
      if (!this.selectedBet.odds || !this.selectedBet.stake) return "N/A";
      const isBonus = this.selectedBet.currencyMethod === "bonus";
      const payout = this.selectedBet.stake * this.selectedBet.odds;
      return formatCurrencyBuiltInFunc(
        isBonus ? payout - this.selectedBet.stake : payout
      );
    },
    editAmendOdds() {
      if (!this.editBet) return 0;
      if (this.editBet.type === "sgm") {
        const sgm = (this.editBet.sgmGroups || [])[0];
        return sgm ? Number(sgm.newOdds) || 0 : 0;
      }
      if (this.editBet.type === "multi") {
        const selOdds = (this.editBet.selections || []).reduce(
          (acc, sel) => acc * (Number(sel.newOdds) || 0),
          1
        );
        const sgmOdds = (this.editBet.sgmGroups || []).reduce(
          (acc, sgm) => acc * (Number(sgm.newOdds) || 0),
          1
        );
        return selOdds * sgmOdds;
      }
      return this.editBet.newOdds || 0;
    },
    comboColumnsShown() {
      return {
        win: this.currentCombos.some((c) => c.Win && c.Win.length > 0),
        top2: this.currentCombos.some((c) => c.Top2 && c.Top2.length > 0),
        top3: this.currentCombos.some((c) => c.Top3 && c.Top3.length > 0),
        top4: this.currentCombos.some((c) => c.Top4 && c.Top4.length > 0),
      };
    },
    comboGridCols() {
      const shown = this.comboColumnsShown;
      const cols = ["1fr"];
      if (shown.win) cols.push("1fr");
      if (shown.top2) cols.push("1fr");
      if (shown.top3) cols.push("1fr");
      if (shown.top4) cols.push("1fr");
      cols.push("2fr");
      cols.push("1.2fr");
      return cols.join(" ");
    },
  },
  mounted() {
    this.handleSearchDebounced = debounce(this.handleSearch, 300);
  },
  watch: {
    search() {
      this.handleSearchDebounced();
    },
    selectedBet(newVal) {
      this.localFinalManualSet = Boolean(newVal?.isFinalManualSet);
    },
  },
  methods: {
    ...mapActions({
      asyncBetslips: "trading/list/getBetslips",
      udpateStatusBetslip: "trading/betslip/udpateStatusBetslip",
      udpateStakeOddsBetslip: "trading/betslip/udpateStakeOddsBetslip",
      udpateResultBetslip: "trading/betslip/udpateResultBetslip",
      updateMigratedResultBetslip: "trading/betslip/updateMigratedResultBetslip",
      manualResultSgmBetslip: "trading/betslip/manualResultSgmBetslip",
      manualResultBetslip: "trading/betslip/manualResultBetslip",
      previewManualResultBetslip: "trading/betslip/previewManualResultBetslip",
      voidSportSelections: "trading/betslip/voidSportSelections",
      updateRunnersOfRace: "trading/racing/updateRunnersOfRace",
      updateRaceDetail: "trading/racing/updateRaceDetail",
    }),
    formatCurrencyBuiltInFunc,
    format,
    handleSearch() {},
    openManualResult(raceId, racingType) {
      this.selectedRaceId = raceId;
      this.selectedRacingType = racingType;
      this.$bvModal.show("betslip-manual-result-modal");
    },
    openSgmManualResult(item) {
      const modal = this.$refs.sgmManualResultModal;
      if (modal && modal.openModal) modal.openModal(item);
    },
    canManualResultBet,
    openBetManualResult() {
      const modal = this.$refs.betslipManualResultModal;
      if (modal && modal.openModal)
        modal.openModal(this.selectedBet, this.getBetTypeLabel(this.selectedBet));
    },
    // Cancels one runner of this exotic bet only (not the race-wide scratching)
    async handleCancelExoticRunner(sel) {
      const bet = this.selectedBet;
      const betResult = toBetResult(bet.result);
      // A winning bet needs the dividend again, so go through the full form
      if (betResult === "win") {
        const modal = this.$refs.betslipManualResultModal;
        if (modal && modal.openModal)
          modal.openModal(bet, this.getBetTypeLabel(bet), { voidLegIds: [sel.id] });
        return;
      }
      const payload = {
        id: bet.id,
        mode: "exotic",
        betResult,
        legs: [{ legId: sel.id, cancelled: true }],
      };
      this.cancellingLegId = sel.id;
      try {
        const preview = await this.previewManualResultBetslip(payload);
        if (!preview) return;
        const confirmed = await this.$bvModal.msgBoxConfirm(
          buildPreviewConfirmMessage(this.$createElement, preview, {
            betLabel: bet.displayId || bet.id,
            oddsLabel: "Dividend",
            intro: `Cancel runner "${sel.runnerNo}. ${sel.runnerName}" for this bet only?`,
          }),
          {
            title: "Cancel Runner",
            okVariant: "warning",
            okTitle: "Cancel Runner",
            cancelTitle: "Close",
            centered: true,
          }
        );
        if (!confirmed) return;
        const res = await this.manualResultBetslip(payload);
        if (!res) return;
        this.showToastSuccess("Success", "Runner cancelled for this bet.");
        this.$emit("refresh");
      } finally {
        this.cancellingLegId = null;
      }
    },
    onSgmResultSuccess() {
      this.$emit("refresh");
      this.closeModal();
    },
    closeModal() {
      this.$bvModal.hide("bet-info");
    },
    copyUserId() {
      if (!this.selectedBet) return;
      navigator.clipboard.writeText(
        this.selectedBet.userId || this.selectedBet.id
      );
      this.showToastSuccess("Copied!", "User ID copied to clipboard.");
    },
    openCustomerPage() {
      if (!this.selectedBet) return;
      const userId = this.selectedBet.userId || this.selectedBet.id;
      if (!userId) return;
      const route = this.$router.resolve({
        name: "customers-view",
        params: { id: userId },
      });
      window.open(route.href, "_blank");
    },
    getBetTypeLabel(bet) {
      if (!bet) return "";
      if (bet.type === "single" && bet.selections && bet.selections[0]) {
        const sel = bet.selections[0];
        const typeLabel = sel.selectionType
          ? sel.selectionType.charAt(0).toUpperCase() +
            sel.selectionType.slice(1)
          : "";
        const subType = bet.subType ? ` (${bet.subType.toUpperCase()})` : "";
        return typeLabel ? `${typeLabel}${subType}` : `Single${subType}`;
      }
      if (bet.type === "multi") return `Multi (TBF)`;
      const typeMap = {
        quinella: "Quinella",
        exacta: "Exacta",
        trifecta: "Trifecta",
        first4: "First Four (SUP)",
        "daily-double": "Daily Double",
        "running-double": "Running Double",
        treble: "Treble",
        srm: "SRM",
        sgm: "SGM",
        quaddie: "Quaddie",
        "combo-racing": "Combo Racing",
      };
      return typeMap[bet.type] || bet.type || "";
    },
    getSportLabel(sel) {
      if (sel.eventTitle) {
        const sport = sel.sportReport || sel.categoryReport || "";
        return sport ? `${sport} - ${sel.eventTitle}` : sel.eventTitle;
      }
      if (sel.raceId) {
        const typeMap = {
          R: "Thoroughbred",
          G: "Greyhound",
          H: "Harness",
          T: "Thoroughbred",
        };
        return typeMap[sel.meetingType] || "Racing";
      }
      return "-";
    },
    resultLabel(result) {
      if (!result) return "Unresulted";
      const map = {
        "resulted-win": "Win",
        "resulted-loss": "Loss",
        "bet-cancelled": "Cancelled",
        "bet-pending": "Unresulted",
        "bet-refunded": "Refunded",
        rejected: "Rejected",
      };
      return map[result] || result;
    },
    resultBadgeVariant(result) {
      if (!result) return "light-secondary";
      const map = {
        "resulted-win": "light-success",
        "resulted-loss": "light-danger",
        "bet-cancelled": "light-secondary",
        "bet-refunded": "light-danger",
        rejected: "light-danger",
      };
      return map[result] || "light-secondary";
    },
    openModalAmendBet() {
      let regularSelections;
      let sgmGroups;
      let srmGroups;

      if (this.selectedBet.type === "sgm") {
        // SGM bet: use sgmGroupsResponse for odds
        regularSelections = [];
        sgmGroups = (this.selectedBet.sgmGroupsResponse || []).map((sgm) => ({
          id: sgm.id,
          odds: sgm.odds,
          newOdds: sgm.odds,
        }));
        srmGroups = [];
      } else {
        // Multi or other: separate regular selections from SGM and SRM groups
        regularSelections = (this.selectedBet.selections || [])
          .filter(
            (sel) =>
              (sel.selectionType !== "sgm" && sel.selectionType !== "srm") ||
              !Array.isArray(sel.selections)
          )
          .map((sel) => ({ ...sel, newOdds: sel.odds }));
        sgmGroups = (this.selectedBet.selections || [])
          .filter((sel) => sel.selectionType === "sgm" && Array.isArray(sel.selections))
          .map((sel) => ({
            id: sel.groupBetId,
            odds: sel.odds,
            newOdds: sel.odds,
          }));
        srmGroups = (this.selectedBet.selections || [])
          .filter((sel) => sel.selectionType === "srm" && Array.isArray(sel.selections))
          .map((sel) => ({
            id: sel.groupBetId,
            odds: sel.odds,
            newOdds: sel.odds,
          }));
      }

      this.editBet = {
        ...this.selectedBet,
        newStake: this.selectedBet.stake,
        newOdds: this.selectedBet.odds,
        selections: regularSelections,
        sgmGroups,
        srmGroups,
      };
      this.$refs.amendModal.show();
    },
    closeModalInfoBet() {
      this.$bvModal.hide("bet-info");
    },
    closeModalAmendBet() {
      this.$refs.amendModal.hide();
    },
    statusVariant(status) {
      switch (status) {
        case "active":
          return "success";
        case "declined":
          return "danger";
        case "pending":
          return "warning";
        case "transferred":
          return "info";
        case "approved":
          return "primary";
        default:
          return "secondary";
      }
    },
    resultVariant(result) {
      switch (result) {
        case "resulted-win":
        case "Win":
          return "success";
        case "resulted-loss":
        case "Lose":
        case "bet-refunded":
          return "danger";
        case "FullyRefunded":
          return "primary";
        case "Void":
          return "secondary";
        case "Draw":
          return "info";
        default:
          return "warning";
      }
    },
    isComboBetType(betType) {
      const types = [
        "trifecta",
        "first4",
        "quinella",
        "exacta",
        "quaddie",
        "running-double",
        "daily-double",
        "treble",
      ];
      return types.includes(betType);
    },
    isExoticBetType(betType) {
      const types = ["trifecta", "first4", "quinella", "exacta", "srm"];
      return types.includes(betType);
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    showModal(type, item) {
      this.action = { item, type };
      if (type === "cancel-bet")
        this.setModal(
          "Cancel Bet",
          "Are you sure you want to cancel this bet?"
        );
      if (type === "approve-bet")
        this.setModal(
          "Approve Bet",
          "Are you sure you want to approve this bet?"
        );
      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { type } = this.action;
      if (type === "cancel-bet") await this.handleCancelBet();
      if (type === "approve-bet") await this.handleApproveBet();
      if (!this.isLoading) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleCancelBet() {
      const res = await this.udpateStatusBetslip({
        id: this.selectedBet.id,
        status: "declined",
      });
      if (res) {
        this.$emit("refresh");
        this.closeModalInfoBet();
        this.showToastSuccess("Success", "Cancel bet successfully!");
      }
    },
    async handleApproveBet() {
      const res = await this.udpateStatusBetslip({
        id: this.selectedBet.id,
        status: "active",
      });
      if (res) {
        this.$emit("refresh");
        this.closeModalInfoBet();
        this.showToastSuccess("Success", "Approve bet successfully!");
      }
    },
    async handleSaveAmendBet() {
      let isChangeAnyOdds = false;
      let payload = {
        id: this.editBet.id,
        stake: Number(this.editBet.newStake),
      };

      if (this.editBet.type === "sgm") {
        // SGM: send sgmGroups
        isChangeAnyOdds = (this.editBet.sgmGroups || []).some(
          (sgm) => Number(sgm.newOdds) !== Number(sgm.odds)
        );
        if (isChangeAnyOdds) {
          payload.sgmGroups = this.editBet.sgmGroups.map((sgm) => ({
            id: sgm.id,
            odds: Number(sgm.newOdds),
          }));
        }
      } else {
        // Multi or other
        const isChangeSelOdds = this.editBet.selections.some(
          (sel) => Number(sel.newOdds) !== Number(sel.odds) && !!sel.newOdds
        );
        const isChangeSgmOdds = (this.editBet.sgmGroups || []).some(
          (sgm) => Number(sgm.newOdds) !== Number(sgm.odds) && !!sgm.newOdds
        );
        const isChangeSrmOdds = (this.editBet.srmGroups || []).some(
          (srm) => Number(srm.newOdds) !== Number(srm.odds) && !!srm.newOdds
        );
        isChangeAnyOdds = isChangeSelOdds || isChangeSgmOdds || isChangeSrmOdds;
        if (isChangeAnyOdds) {
          payload.selections = this.editBet.selections.map((sel) => ({
            id: sel.id,
            odds: Number(sel.newOdds),
            category: sel.meetingName ? "race" : "event",
          }));
          if (this.editBet.sgmGroups && this.editBet.sgmGroups.length > 0) {
            payload.sgmGroups = this.editBet.sgmGroups.map((sgm) => ({
              id: sgm.id,
              odds: Number(sgm.newOdds),
            }));
          }
          if (this.editBet.srmGroups && this.editBet.srmGroups.length > 0) {
            payload.srmGroups = this.editBet.srmGroups.map((srm) => ({
              id: srm.id,
              odds: Number(srm.newOdds),
            }));
          }
        }
      }

      const resStake = await this.udpateStakeOddsBetslip(payload);
      if (resStake) {
        this.showToastSuccess("Success", "Update bet successfully!");
        // return await this.handleChangeResultBet();
        this.$emit("refresh");
        this.closeModalAmendBet();
        this.closeModalInfoBet();
      }
      // }
      // await this.handleChangeResultBet();
    },
    async handleChangeResultBet() {
      if (this.editBet.result !== this.selectedBet.result) {
        const resResult = await this.udpateResultBetslip({
          id: this.editBet.id,
          result: !this.editBet.result ? null : this.editBet.result,
        });
        if (resResult) {
          this.showToastSuccess("Success", "Update result successfully!");
        }
      }
      this.$emit("refresh");
      this.closeModalAmendBet();
      this.closeModalInfoBet();
    },
    convertSelectionType(selection) {
      if (selection.selectionType === "top-k") {
        return `More Places - Top ${selection.topK}`;
      }
      return selection.selectionType
        ? selection.selectionType.charAt(0).toUpperCase() +
            selection.selectionType.slice(1)
        : "";
    },
    checkResultBetTypeCombo(l, race, ind) {
      if (!!l.result) return l.result;

      if (race.type === "srm") {
        return !!l.finalPosition && l.finalPosition <= ind ? "Win" : "Lose";
      }

      const result =
        (!!ind &&
          ind === l.finalPosition &&
          !!l.finalPosition &&
          race.type !== "quinella" &&
          race.category !== "quaddie") ||
        (race.type === "quinella" &&
          !!l.finalPosition &&
          l.finalPosition <= 2)
          ? "Win"
          : "Lose";
      return result;
    },
    async hideModalEditResult() {
      this.selectedSelection = null;
      this.$emit("refresh");
    },
    openModalUpdateResultSelection(sel) {
      this.selectedSelection = sel;
      const modal = this.$refs.resultModal;
      if (modal && modal.openModal) {
        modal.openModal();
      }
    },
    canAbandonRace(raceId, race) {
      return !!raceId && (!race || race.finalStatus !== "ABANDONED");
    },
    // Same update as racing view's Abandon Race, minus the disable-crawl prompt
    async handleAbandonRace(raceId, race) {
      if (!raceId) return;
      const raceLabel = [
        race && race.raceNumber ? `Race ${race.raceNumber}` : null,
        race && race.meetingName,
      ]
        .filter(Boolean)
        .join(" - ");
      const message = this.$createElement(
        "div",
        { style: { color: "#1a1a1a", fontSize: "14px" } },
        `Abandon ${raceLabel || "this race"}? All active bets on this race will be cancelled and refunded. This action cannot be undone.`
      );
      const confirmed = await this.$bvModal.msgBoxConfirm(message, {
        title: "Abandon Race",
        okVariant: "danger",
        okTitle: "Abandon",
        cancelTitle: "Cancel",
        centered: true,
      });
      if (!confirmed) return;
      this.abandoningRaceId = raceId;
      try {
        const result = await this.updateRaceDetail({
          raceId,
          finalStatus: "ABANDONED",
        });
        if (result) {
          this.showToastSuccess("Success", "Abandon race successfully!");
          this.$emit("refresh");
        }
      } finally {
        this.abandoningRaceId = null;
      }
    },
    getRunnerId(sel) {
      return sel.runnerId || sel.selectionId;
    },
    canScratchRunner(sel) {
      const runnerId = this.getRunnerId(sel);
      return (
        !!runnerId &&
        !sel.scratched &&
        !this.scratchedRunnerIds.includes(runnerId)
      );
    },
    // Same payload as Competitors save with only `scratched` changed, so no disable-sync prompt is needed
    async handleScratchRunner(sel, fallbackRaceId) {
      const raceId = sel.raceId || fallbackRaceId;
      const runnerId = this.getRunnerId(sel);
      if (!raceId || !runnerId) return;
      const message = this.$createElement(
        "div",
        { style: { color: "#1a1a1a", fontSize: "14px" } },
        `Scratch runner "${sel.runnerNo}. ${sel.runnerName}"?`
      );
      const confirmed = await this.$bvModal.msgBoxConfirm(message, {
        title: "Scratch Runner",
        okVariant: "warning",
        okTitle: "Scratch",
        cancelTitle: "Cancel",
        centered: true,
      });
      if (!confirmed) return;
      this.togglingScratchRunnerId = runnerId;
      try {
        const res = await this.updateRunnersOfRace({
          raceId,
          runners: [{ runnerId, scratched: 1 }],
        });
        if (res === undefined) return;
        this.scratchedRunnerIds.push(runnerId);
        this.showToastSuccess("Success", "Scratch runner successfully!");
        this.$emit("refresh");
      } finally {
        this.togglingScratchRunnerId = null;
      }
    },
    canVoidSelection(sel) {
      return (
        sel &&
        sel.selectionType === "event" &&
        !!sel.selectionId &&
        sel.status !== "cancelled"
      );
    },
    async handleVoidSelection(sel) {
      const label = [sel.eventTitle, sel.marketName, sel.name]
        .filter(Boolean)
        .join(" — ");
      const message = this.$createElement(
        "div",
        { style: { color: "#1a1a1a", fontSize: "14px" } },
        `Void "${label}"? All bets containing this selection will be refunded for this leg.`
      );
      const confirmed = await this.$bvModal.msgBoxConfirm(message, {
        title: "Void Selection",
        okVariant: "danger",
        okTitle: "Void",
        cancelTitle: "Cancel",
        centered: true,
      });
      if (!confirmed) return;
      const ok = await this.voidSportSelections([sel.selectionId]);
      if (ok !== undefined) {
        this.showToastSuccess("Success", "Selection voided successfully!");
        this.$emit("refresh");
      }
    },
    parseCombos(item) {
      try {
        const json = (item && item.selectionsJson)
          || (this.selectedBet && this.selectedBet.selectionsJson)
          || null;
        if (!json) return [];
        const parsed = JSON.parse(json);
        if (!parsed || typeof parsed !== "object") return [];
        return Object.values(parsed);
      } catch (e) {
        return [];
      }
    },
    openComboModal(item) {
      this.currentCombos = this.parseCombos(item);
      this.showComboModal = true;
    },
    buildBmLabel(item) {
      const odds =
        item.odds != null && item.odds !== 0
          ? "@" + Number(item.odds).toFixed(2)
          : "@N/A";
      if (item.raceId) {
        return [
          `Race ${item.raceNumber}`,
          item.meetingName,
          `${item.runnerNo}. ${item.runnerName}${item.barrierPosition ? ` (${item.barrierPosition})` : ""}`,
        ]
          .filter(Boolean)
          .join(" — ") + ` ${odds}`;
      }
      return [item.eventTitle, item.marketName, item.name]
        .filter(Boolean)
        .join(" — ") + ` ${odds}`;
    },
    openBmResultModal(rawSelections, isSgm = false, sgmGroupResult = null, sgmGroupId = null, sgmGroupOdds = null) {
      this.bmResultSelections = (rawSelections || []).map((sel, i) => ({
        id: sel.id || String(i),
        label: this.buildBmLabel(sel),
        result: sel.result || null,
      }));
      this.bmIsSgm = isSgm;
      this.bmSgmGroupResult = sgmGroupResult || null;
      this.bmSgmGroupId = sgmGroupId || null;
      this.bmSgmGroupOdds = sgmGroupOdds != null ? sgmGroupOdds : null;
      this.bmIsExotic = ['quinella', 'exacta', 'trifecta', 'first4'].includes(
        this.selectedBet && this.selectedBet.type
      );
      this.showBmResultModal = true;
    },
    async onBmResultSave(results) {
      const { __sgmResult, ...selResults } = results;
      let payload;

      if (this.bmIsExotic) {
        payload = {
          exoticSelectionResults: Object.entries(selResults)
            .map(([id, result]) => ({ id, result })),
        };
      } else if (this.bmIsSgm) {
        payload = {
          selectionResults: [
            {
              id: this.bmSgmGroupId,
              result: __sgmResult,
              legs: Object.entries(selResults).map(([id, result]) => ({ id, result })),
            },
          ],
        };
      } else {
        payload = {
          selectionResults: Object.entries(selResults)
            .map(([id, result]) => ({ id, result })),
        };
      }

      if (
        this.selectedBet.acceptanceSource === 'bm' &&
        ['single', 'multi'].includes(this.selectedBet.type) &&
        this.selectedBet.result !== 'resulted-loss'
      ) {
        if (Object.values(selResults).some(r => r === 'Lose')) {
          payload.result = 'resulted-loss';
        }
      }

      if (this.selectedBet.acceptanceSource === 'bm') {
        const selections = this.selectedBet.selections || [];
        const allSelectionsResulted = selections.every(sel => {
          if (sel.selectionType === 'sgm' && Array.isArray(sel.selections)) {
            const groupResult = (this.bmIsSgm && this.bmSgmGroupId === sel.groupBetId)
              ? __sgmResult
              : sel.result;
            if (!groupResult) return false;
            return sel.selections.every(leg => !!(selResults[leg.id] ?? leg.result));
          }
          return !!(selResults[sel.id] ?? sel.result);
        });
        const betResult = payload.result || this.selectedBet.result;
        if (allSelectionsResulted && betResult && betResult !== 'bet-pending' && !this.selectedBet.isFinalManualSet) {
          payload.isFinalManualSet = true;
        }
      }

      const ok = await this.updateMigratedResultBetslip({
        id: this.selectedBet.id,
        ...payload,
      });
      if (ok !== undefined) {
        this.showToastSuccess('Success', 'Selection result updated!');
        this.showBmResultModal = false;
        this.$emit('refresh');
      }
    },
    async onBmAmendSave(payload) {
      if (!this.selectedBet.isFinalManualSet) {
        const betResult = payload.result || this.selectedBet.result;
        if (betResult && betResult !== 'bet-pending') {
          const selections = this.selectedBet.selections || [];
          const allSelectionsResulted = selections.every(sel => {
            if (sel.selectionType === 'sgm' && Array.isArray(sel.selections)) {
              return !!sel.result && sel.selections.every(leg => !!leg.result);
            }
            return !!sel.result;
          });
          if (allSelectionsResulted) {
            payload.isFinalManualSet = true;
          }
        }
      }
      const ok = await this.updateMigratedResultBetslip({
        id: this.selectedBet.id,
        ...payload,
      });
      if (ok !== undefined) {
        this.showToastSuccess("Success", "Bet updated successfully!");
        this.showBmAmendModal = false;
        this.$emit("refresh");
      }
    },
    async onCheckboxFinalizeResults() {
      this.finalizingResults = true;
      try {
        const ok = await this.updateMigratedResultBetslip({
          id: this.selectedBet.id,
          isFinalManualSet: true,
        });
        if (ok !== undefined) {
          this.showToastSuccess('Success', 'Bet marked as all results finalized.');
          this.$emit('refresh');
          this.closeModal();
        } else {
          this.localFinalManualSet = Boolean(this.selectedBet && this.selectedBet.isFinalManualSet);
        }
      } finally {
        this.finalizingResults = false;
      }
    },
    formatOdds(value) {
      if (!value && value !== 0) return "-";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();
    return { showToastSuccess, showToastError };
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
